module.exports = __webpack_public_path__ + "img/winS2-bg-cn.4789a3ac.jpg";